import { default as initDirectories } from './initDirectories';

const operations = {
  initDirectories
};

export default operations;

